import { all, fork } from 'redux-saga/effects';
import uploadDeviationSaga from './deviations';
import uploadAttachmentSaga from './attachments';
import uploadDocumentSaga from './legalDocuments';
export default function* saga() {
    yield all([
        fork(uploadDeviationSaga),
        fork(uploadAttachmentSaga),
        fork(uploadDocumentSaga)
    ]);
}

//# sourceMappingURL=index.js.map